import React, { memo } from 'react';

const Icon = memo(({ name, className = '' }) => {
  const icons = {
    // Navigation & General UI
    'chevron-left': '⬅️',
    'chevron-right': '➡️',
    'chevron-up': '▲',
    'chevron-down': '▼',
    'arrow-right': '→',
    'arrow-left': '←',
    'arrow-up': '↑',
    'arrow-down': '↓',
    'home': '🏠',
    'book': '📖',
    'user': '👤',
    'users': '👥',
    'settings': '⚙️',
    'info': 'ℹ️',
    'help': '❔',
    'search': '🔍',
    'add': '➕',
    'edit': '✏️',
    'save': '💾',
    'lock': '🔒',
    'key': '🔑',
    'logout': '🚪',
    'switch-user': '🧑‍🤝‍🧑',
    'trash': '🗑️',
    'warning': '⚠️',
    'x': '❌',
    'spinner': '🌀',
    'external-link': '🔗',

    // Media & Sound
    'play': '▶️',
    'pause': '⏸️',
    'forward': '⏩',
    'backward': '⏪',
    'repeat': '🔁',
    'shuffle': '🔀',
    'refresh': '🔄',
    'volume-up': '🔊',
    'volume-off': '🔇',
    'mic': '🎤',
    'camera': '📸',

    // Status & Feedback
    'check': '✅',
    'lightbulb': '💡',
    'star': '⭐',
    'trophy': '🏆',
    'heart': '❤️',
    'target': '🎯',
    'rocket': '🚀',
    'hourglass': '⏳',
    'gift': '🎁',
    'bell': '🔔',
    'download': '⬇️',
    'mail': '✉️',
    'family': '👨‍👩‍👧‍👦',
    'shield': '🛡️',
    'zap': '⚡',
    'wifi-off': '📵',

    // Charts & Analytics
    'chart-bar': '📊',
    'chart-line': '📈',
    'server': '🖥️',
    'exclamation-triangle': '⚠️',

    // Other
    'map': '🗺️',
    'music': '🎵',
    'globe': '🌍',
    'party-popper': '🎉',
  };

  const selectedIcon = icons[name] || '❓';
  const finalClassName = `inline-block ${className}`;

  return (
    <span role="img" aria-label={`${name} icon`} className={finalClassName}>
      {selectedIcon}
    </span>
  );
});

export default Icon;
